import {Checkbox, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";

export type PageItem = "preamble" | "abbreviations" | "openings" | "frameProfiles" | "anchorElevations" | "screenElevations" | "doorElevations" | "hardwareElevations" | "liteKitProfiles"
type PagesObj = PageItem[]

const allPages: {key: PageItem; label: string}[] = [
    {key: "preamble", label: "Preamble"},
    {key: "abbreviations", label: "Abbreviations"},
    {key: "openings", label: "Openings"},
    {key: "frameProfiles", label: "Frame Profiles"},
    {key: "anchorElevations", label: "Anchor Elevations"},
    {key: "screenElevations", label: "Screen Elevations"},
    {key: "doorElevations", label: "Door Elevations"},
    {key: "hardwareElevations", label: "Hardware Elevations"},
    {key: "liteKitProfiles", label: "Lite Kit Profiles & Glazing"},
]

export const defaultPages: PagesObj = allPages.map(p => p.key)

export function PagesTab(props: {
    value: PagesObj;
    onChange(value: PagesObj): void;
}) {
    return (
        <List dense>
            {allPages.map(p => (
                <ListItemButton key={p.key} onClick={() => {
                    if (props.value.includes(p.key)) {
                        props.onChange(props.value.filter(v => v !== p.key))
                    } else {
                        props.onChange([...props.value, p.key])
                    }
                }} dense>
                    <ListItemIcon>
                        <Checkbox
                            edge="start"
                            checked={props.value.includes(p.key)}
                            tabIndex={-1}
                            disableRipple
                        />
                    </ListItemIcon>
                    <ListItemText primary={p.label} />
                </ListItemButton>
            ))}
        </List>
    )
}